



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import InstitutionState from '@/models/Settings/Institutions/InstitutionState';

@Component({ name: 'InstitutionState', })
export default class extends SaascadaVue {

    @Prop({ required: true })
    state: InstitutionState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.state) {
            case InstitutionState.Enabled:
                color = "success--text";
                break;
            case InstitutionState.Disabled:
                color = "error--text";
                break;
        }
        return color;
    }

}
